import {
  TOTAL_FILES_MAX_SIZE,
  MAX_FILES_IN_EACH_API,
  NO_OF_CONCURRENT_API_CALLS as TOTAL_API_CALLS
} from 'src/config';

export function groupFilesBySize(
  acceptedFiles,
  inGroups = true
): [][] | { [z: string]: [] } {
  const maxGroupSize = TOTAL_FILES_MAX_SIZE;
  let numberOfMaxFilesInGroup = MAX_FILES_IN_EACH_API;
  const groupedFiles = [];
  let currentGroup = [];
  let currentGroupSize = 0;
  const largerFiles = [];

  acceptedFiles.forEach((file) => {
    const fileSizeMb = file.size / (1024 * 1024);
    if (fileSizeMb >= maxGroupSize) {
      largerFiles.push(file);
    } else {
      if (
        currentGroup.length >= numberOfMaxFilesInGroup ||
        currentGroupSize + fileSizeMb > maxGroupSize
      ) {
        groupedFiles.push(currentGroup);
        currentGroup = [];
        currentGroupSize = 0;
      }

      currentGroup.push(file);
      currentGroupSize += fileSizeMb;
    }
  });

  if (currentGroup.length > 0) {
    groupedFiles.push(currentGroup);
  }

  if (largerFiles.length) {
    largerFiles.forEach((largeFile) => groupedFiles.push([largeFile]));
  }

  if (inGroups) {
    return groupArrayIntoObject(groupedFiles);
  }
  return groupedFiles;
}

function groupArrayIntoObject(arrays) {
  const finalObj = {};

  for (let i = 0; i < arrays.length; i += TOTAL_API_CALLS) {
    const groupName = `group${Math.floor(i / TOTAL_API_CALLS) + 1}`;
    finalObj[groupName] = arrays.slice(i, i + TOTAL_API_CALLS);
  }

  return finalObj;
}
